export enum MaintenanceRequestStatus {
  None = 0,
  InProgress_Assigned = 1,
  InProgress_Unassigned = 2,
  Rejected = 3,
  Completed = 4,
}